import React from 'react';
import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import { IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { submitForm } from '../../store/actions/ProductActions';

const TableBlockProduct = ({ row, col, value }) => {
  const dispatch = useDispatch();

  const token = useSelector(state => state?.auth?.token);

  const handleProductLock = () => {
    const submitValues = { isBlocked: !value, isRecommended: false };
    dispatch(submitForm('editProduct', token, submitValues, row?._id));
  };

  return (
    <>
      <IconButton onClick={handleProductLock}>
        {!value ? <LockOpenTwoToneIcon /> : <LockTwoToneIcon />}
      </IconButton>
    </>
  );
};

export default TableBlockProduct;
